export default "__VITE_ASSET__2vdGtCOO__"